module.exports = __webpack_public_path__ + "img/29.efadc5f9.jpg";